export default __webpack_public_path__ + "static/media/dinner.15586241.png";